const { verificarTipoDeArquivo } = require("./validation");
const { enviaMensagemChat } = require("./chat_features");
const { vaporStoreWithFilename } = require("./vapor_store_helper");

export function filesToArray(arquivos) {
    let files = [];
    for (let i = 0; i < arquivos.length; i++) {
        files.push(arquivos[i]);
    }
    return files;
}

export function uploadOtherFile(file, tipo, input, legenda = null, envioEmLote = false) {
    const fileName = file.name;
    const contextChat = $(input).closest(".oportunidade-chat");

    if (!verificarTipoDeArquivo(tipo, file.type)) {
        showToastDanger($("body"), "Arquivo inválido, tente novamente.");
        return false;
    }

    $(".js-sending-chat", contextChat).removeClass("d-none");
    vaporStoreWithFilename(file, {
        baseURL: siteUrl("/painel"),
        progress: (progress) => {
            //this.uploadProgress = Math.round(progress * 100);
        },
    })
        .then((response) => {
            enviaMensagemChat(
                contextChat,
                response.uuid,
                file,
                tipo,
                file.type,
                fileName,
                null,
                legenda,
                envioEmLote
            );
        })
        .catch((error) => {
            console.log(error);
            showToastDanger($("body"), "Não foi possível enviar o arquivo");
            $(".js-sending-chat", contextChat).addClass("d-none");
        });
}

export function uploadImg(file, tipo, input, legenda = null, envioEmLote = false) {
    const fileName = file.name;
    const contextChat = $(input).closest(".oportunidade-chat");

    if (!verificarTipoDeArquivo(tipo, file.type)) {
        showToastDanger($("body"), "Arquivo inválido, tente novamente.");
        return false;
    }

    $(".js-sending-chat", contextChat).removeClass("d-none");

    const chatContext = input.closest(".oportunidade-chat");
    const canvas = chatContext.getElementsByClassName("js-canvas-imagem")[0];
    const canvasImg = canvas.getContext("2d");

    const reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        const tmpImage = new Image();
        tmpImage.src = e.target.result;
        tmpImage.crossOrigin = "anonymous";
        tmpImage.onload = function () {
            canvas.width = this.width;
            canvas.height = this.height;

            canvasImg.drawImage(tmpImage, 0, 0);
            const imgData = canvasImg.getImageData(
                0,
                0,
                canvas.width,
                canvas.height
            );
            const data = imgData.data;
            let transparent = false;
            for (let i = 0; i < data.length; i += 4) {
                const alfa = data[i + 3];
                if (alfa < 255) {
                    transparent = true;
                    break;
                }
            }
            if (transparent || file.type == "image/webp") {
                canvasImg.fillStyle = "#FFFFFF";
                canvasImg.fillRect(0, 0, this.width, this.height);
                canvasImg.drawImage(tmpImage, 0, 0);
                canvas.toBlob((blob) => {
                    // Preservar nome original do arquivo, apenas mudando extensão para .jpg
                    const originalName = fileName.replace(/\.[^/.]+$/, "") || "imagem";
                    const newFile = new File([blob], `${originalName}.jpg`, {
                        type: "image/jpeg",
                    });
                    vaporStoreWithFilename(newFile, {
                        baseURL: siteUrl("/painel"),
                        progress: (progress) => {
                            this.uploadProgress = Math.round(progress * 100);
                        },
                    })
                        .then((response) => {
                            enviaMensagemChat(
                                contextChat,
                                response.uuid,
                                newFile,
                                tipo,
                                newFile.type,
                                newFile.name,
                                null,
                                legenda,
                                envioEmLote
                            );
                        })
                        .catch((error) => {
                            alert("Não foi possível enviar a imagem");
                            $(".js-sending-chat", contextChat).addClass(
                                "d-none"
                            );
                        });
                }, "image/jpeg");
            } else {
                vaporStoreWithFilename(file, {
                    baseURL: siteUrl("/painel"),
                    progress: (progress) => {
                        this.uploadProgress = Math.round(progress * 100);
                    },
                })
                    .then((response) => {
                        enviaMensagemChat(
                            contextChat,
                            response.uuid,
                            file,
                            tipo,
                            file.type,
                            file.name,
                            null,
                            legenda,
                            envioEmLote
                        );
                    })
                    .catch((error) => {
                        alert("Não foi possível enviar a imagem");
                        $(".js-sending-chat", contextChat).addClass("d-none");
                    });
            }
        };
    };
}

export async function previewFiles(arquivos) {
    if (arquivos.length) {
        let files = filesToArray(arquivos);
        for (let arquivo of files) {
            const fileID = arquivo.name.replaceAll(/[()+=.#\s]/g, "-");
            const tipo = arquivo.type.includes("video") ? "video" : "image";

            if (!verificarTipoDeArquivo(tipo, arquivo.type)) {
                showToastDanger(
                    $("body"),
                    "Arquivo inválido, tente novamente."
                );
                return false;
            }

            if (tipo == "video") {
                $(`
                    <div id="carousel-item" class="carousel-item">
                        <video controls id="video-tag-${fileID}" class="mt-3 ml-3" style="max-height: 300px;">
                            Seu navegador não suporta a tag de vídeo.
                        </video>
                        <div class="form-group mt-3">
                            <input type="text" class="form-control" id="legenda-${fileID}" name="legenda" placeholder="Adicione uma legenda">
                        </div>
                    </div>
                `).appendTo("#media-insert");

                const reader = new FileReader();

                reader.readAsDataURL(arquivo);
                reader.onload = function (e) {
                    $(`#video-tag-${fileID}`).attr("src", e.target.result);
                };
            } else {
                $(`
                    <div id="carousel-item" class="carousel-item">
                        <img src="" alt="" class="img-fluid mt-3 ml-3" id="image-tag-${fileID}" style="max-height: 300px;">
                        <div class="form-group mt-3">
                            <input type="text" class="form-control" id="legenda-${fileID}" name="legenda" placeholder="Adicione uma legenda">
                        </div>
                    </div>
                `).appendTo("#media-insert");

                const reader = new FileReader();

                reader.readAsDataURL(arquivo);

                reader.onload = function (e) {
                    $(`#image-tag-${fileID}`).attr("src", e.target.result);
                };
            }
        }

        $("#carousel-item").first().addClass("active");
        $("#modalImagemEnvio").modal('show');
    }
}

export async function uploadFiles(arquivos) {
    const input = window.inputFilesChat;
    if (arquivos.length) {
        let files = filesToArray(arquivos);
        const envioEmLote = files.length > 1;
        for (let arquivo of files) {
            const fileID = arquivo.name.replaceAll(/[()+=.#\s]/g, "-");
            const legenda = $(`#legenda-${fileID}`).val() || "";
            const tipo = arquivo.type.includes("video") ? "video" : "image";

            if (tipo == "video") {
                uploadOtherFile(arquivo, tipo, input, legenda, envioEmLote);
            } else {
                uploadImg(arquivo, tipo, input, legenda, envioEmLote);
            }
        }
    }

    $("#modalImagemEnvio").modal("hide");
}
